import styled from 'styled-components';

import { body } from '@constants/fonts';

export const PROFILE_CARD_HEIGHT = 80;
export const PROFILE_CARD_WITH_LABEL_HEIGHT = 120;

export const MobileMenuStyle = styled.div<{ closed: boolean }>`
  width: 380px;
  max-width: 80%;
  border-right: 1px solid ${({ theme }) => theme.palette.background.default};
  height: 100%;
  background: ${({ theme }) => theme.palette.background.paper};
  z-index: 1000;
  position: fixed;
  box-shadow: ${({ theme }) => theme.shadows[24]};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  left: 0;
  transition: all 0.35s;
  ${(props) => props.closed && 'left: calc(-80% + -1px);'}
  ${(props) => props.closed && 'box-shadow: none;'}
`;

export const MenuBottom = styled.div`
  background: ${({ theme }) => theme.palette.background.default};
  border-top: 1px solid ${({ theme }) => theme.palette.divider};
  color: ${({ theme }) => theme.palette.text.secondary};
`;
export const Note = styled.div`
  align-self: baseline;
  width: 15px;
  height: 15px;
  -moz-border-radius: 70px;
  -webkit-border-radius: 70px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  color: ${({ theme }) => theme.palette.primary.contrastText};
  align-items: center;
  margin-left: -16px;
  justify-content: center;
  font-size: 12px;

  &:after {
    content: '!';
  }
`;
export const MenuLinks = styled.div<{
  finishLabel: boolean;
}>`
  margin-top: ${(props) => (props.finishLabel ? '130px' : '90px')};
`;

export const ProfileSelector = styled.div<{
  numEntries: number;
  firstProfile: number;
  open: boolean;
}>`
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadows[24]};
  transition:
    max-height 0.3s,
    border-radius 0.3s;
  position: absolute;
  background: ${({ theme }) => theme.palette.background.paper};
  z-index: 10;
  top: 0;
  left: 0;
  width: 100%;
  max-height: ${(props) =>
    props.open
      ? (props.numEntries - 1) * PROFILE_CARD_HEIGHT + props.firstProfile
      : props.firstProfile}px;
  border-bottom-left-radius: ${(props) => (props.open ? '10px' : '0')};
  border-bottom-right-radius: ${(props) => (props.open ? '10px' : '0')};
`;

export const ProfileEntry = styled.div`
  flex-wrap: wrap;
  height: ${PROFILE_CARD_HEIGHT}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
  overflow: hidden;
  cursor: pointer;
`;

export const ProfileText = styled.div<{ active: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${(props) => props.active && 'font-weight: 700;'}
  color: ${(props) =>
    props.active
      ? props.theme.palette.text.primary
      : props.theme.palette.text.secondary};
  margin: 0;

  p {
    color: ${({ theme }) => theme.palette.text.secondary};
    font-size: 14px;
    font-weight: 100;
    margin: 0;
  }
`;

export const ProfileAvatar = styled.div`
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DownArrow = styled.div`
  margin-left: auto;
  margin-right: 10px;
  display: flex;
  cursor: pointer;
`;

export const FinishLabel = styled.div`
  box-sizing: border-box;
  height: 40px;
  width: 90%;
  border: 1px solid ${({ theme }) => theme.palette.primary.main};
  border-radius: 7px;
  background-color: ${({ theme }) => theme.palette.common.accentLightblue};
  box-shadow: ${({ theme }) => theme.shadows[3]};
  margin-right: 5%;
  margin-left: 5%;
  display: flex;
  color: ${({ theme }) => theme.palette.primary.main};
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const Incomplete = styled.div`
  height: 19px;
  color: ${({ theme }) => theme.palette.text.primary}24;
  font-family: ${body};
  font-size: 14px;
  line-height: 19px;
`;
